<div class="property-map" *ngIf="isMapsReady$ | async">
  <google-map width="100%" height="100%" [center]="{ lat: lat, lng: lng }" [options]="mapOptions">
    <map-marker [position]="{ lat: lat, lng: lng }" [options]="markerOptions"></map-marker>
  </google-map>
</div>
